import { combineReducers } from '@reduxjs/toolkit';

import { companyAccessKeysApi } from '~main/actions/companyAccessKeys';
import { companySettingsApi } from '~main/actions/companySettings';
import { documentBatchesApi } from '~main/actions/documentBatches';
import { userFeedbackApi } from '~main/actions/userFeedback';

import app from '~main/reducers/app';
import * as clientsReducers from '~main/reducers/clients';
import formDefaults from '~main/reducers/formDefaults';
import login from '~main/reducers/login';

export const main = {
  ...clientsReducers,
  app,
  formDefaults,
  login,
};

export default combineReducers(main);

export const mainApis = [companyAccessKeysApi, companySettingsApi, documentBatchesApi, userFeedbackApi] as const;
